import React, { useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import { API, deleteCall } from "../../../../../config";
import Spin from "../../../../common/Spin";

const SearchTermDelete = ({
  searchTermId,
  toggleDeleteModal,
  handleDelete,
  showDelete,
}) => {
  const [loading, setLoading] = useState(false);

  const handleSearchTermDelete = async () => {
    try {
      setLoading(true);
      const { data } = await deleteCall(`${API.TERM_DELETE}/${searchTermId}`);
      setLoading(false);
      toast.success(data?.message);
      handleDelete();
    } catch (error) {
      setLoading(false);
      if (error?.response?.data?.errors) {
        Object.keys(error?.response?.data?.errors).forEach((key) => {
          toast.error(error?.response?.data?.errors[key][0]);
        });
      } else {
        toast.error(error?.message);
      }
      return null;
    }
  };
  return (
    <Modal
      size="lg"
      show={showDelete}
      onHide={toggleDeleteModal}
      dialogClassName="modal-50w small-popup review-popup small-review"
      aria-labelledby="contained-modal-title-vcenter"
      className="business-section"
      centered
    >
      <Modal.Header className="mb-0" closeButton>
        Delete Term
      </Modal.Header>
      <Modal.Body>
        {loading && <Spin />}
        <div className="modal-body">
          Are you sure you want to delete this term?
        </div>
        <div className="modal-footer">
          <Button
            type="Button"
            className="btn btn-secondary"
            onClick={() => {
              toggleDeleteModal();
            }}
          >
            Cancel
          </Button>
          <Button
            type="submit"
            className="btn btn-primary"
            data-dismiss="modal"
            onClick={() => {
              handleSearchTermDelete();
            }}
          >
            OK
          </Button>
        </div>
      </Modal.Body>
    </Modal>
    // <div
    //   className="modal fade"
    //   id="deleteSearchTerm"
    //   tabindex="-1"
    //   role="dialog"
    //   aria-labelledby="exampleModalCenterTitle"
    //   aria-hidden="true"
    //   onClick={() => {
    //     toggleDeleteModal();
    //   }}
    // >
    //   <div className="modal-dialog modal-dialog-centered" role="document">
    //     <div className="modal-content">
    //       <div className="modal-header">
    //         <h5 className="modal-title" id="exampleModalLongTitle">
    //           Delete Term
    //         </h5>
    //         <button
    //           type="button"
    //           className="close"
    //           data-dismiss="modal"
    //           aria-label="Close"
    //           onClick={() => {
    //             toggleDeleteModal();
    //           }}
    //         >
    //           <span aria-hidden="true">&times;</span>
    //         </button>
    //       </div>
    //       <div className="modal-body">
    //         Are you sure you want to delete this term?
    //       </div>
    //       <div className="modal-footer">
    //         <button
    //           type="button"
    //           className="btn btn-secondary"
    //           data-dismiss="modal"
    //         >
    //           Cancel
    //         </button>
    //         <button
    //           type="submit"
    //           className="btn btn-primary"
    //           data-dismiss="modal"
    //           onClick={() => {
    //             handleSearchTermDelete();
    //           }}
    //         >
    //           OK
    //         </button>
    //       </div>
    //     </div>
    //   </div>
    // </div>
  );
};

export default SearchTermDelete;
